import { homePagePath } from '@/shared/constants/homeConstants'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

const ErrorFallback = () => {
    const { t: translate } = useTranslation()
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '80vh',
    }
    return (
        <Box sx={containerStyle}>
            <Typography variant="label3">
                {translate('errorFallbackMessage')}
            </Typography>
            <Button href={homePagePath} sx={{ mt: '46px' }}>
                {translate('backToMainPageButton')}
            </Button>
        </Box>
    )
}

export { ErrorFallback }
